import blogLanding from './blog_landing';
import blogLandingFilter from './blog_landingFilter';

// run all related funcs here
const runFuncs = () => {
  blogLanding();
  blogLandingFilter();
};

export default runFuncs;
